import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

const About = () => {
  const { about } = useContent();
  return (
    <div data-testid="about-page" className="pt-36 md:pt-48 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-7">
            <Reveal>
              <p className="text-[0.65rem] uppercase tracking-[0.4em] text-gold mb-6">About the Studio</p>
              <h1 className="font-serif text-4xl sm:text-6xl md:text-7xl font-light tracking-tight leading-[1.05]">
                {about.headline}
              </h1>
            </Reveal>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <Reveal delay={0.15}>
              <p className="text-muted2 leading-relaxed">{about.paragraphs?.[0]}</p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 overflow-hidden">
            <motion.img
              src={about.image}
              alt="Ghajoyan Photo studio work"
              className="w-full aspect-[16/9] object-cover"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </Reveal>

        <div className="grid md:grid-cols-12 gap-12 mt-28">
          <div className="md:col-span-5">
            <Reveal>
              <div className="overflow-hidden">
                <img src={about.image} alt="Behind the camera" className="w-full aspect-[3/4] object-cover" />
              </div>
            </Reveal>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex flex-col justify-center">
            <Reveal>
              <h2 className="font-serif text-3xl md:text-5xl font-light leading-tight mb-8">The philosophy</h2>
              <div className="space-y-6 text-muted2 leading-relaxed text-lg font-light">
                <p>{about.philosophy}</p>
                {about.paragraphs?.[1] && <p>{about.paragraphs[1]}</p>}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-28 border-t border-white/10 pt-16">
          <Reveal>
            <p className="text-[0.65rem] uppercase tracking-[0.35em] text-gold mb-12">What I hold sacred</p>
          </Reveal>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-10">
            {(about.values || []).map((v, i) => (
              <Reveal key={v} delay={(i % 3) * 0.08}>
                <div className="flex items-baseline gap-4 border-b border-white/10 pb-6">
                  <span className="font-serif text-gold text-lg">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-serif text-2xl md:text-3xl font-light">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal>
          <div className="mt-28 text-center">
            <p className="font-serif text-3xl md:text-5xl font-light max-w-3xl mx-auto leading-tight">
              If my work moves you, I'd love to hear the story you want to tell.
            </p>
            <Link to="/contact" data-testid="about-contact-link" className="inline-flex items-center gap-3 mt-10 border border-cream/40 px-10 py-4 text-xs uppercase tracking-[0.25em] hover:bg-cream hover:text-ink transition-colors duration-500">
              Start an Inquiry
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default About;
